<ng-container *ngIf="type === 3 || type === 4">
  <div class="text-center p-2 bg-primary">
    <div class="d-flex align-items-center flex-wrap p-2 border-header">
      <div class="d-none d-lg-flex align-items-center">
        <em class="fa fa-calendar fa-2x mr-3"></em>
      </div>
      <div class="line bg-white d-none d-lg-flex"></div>
      <div class="text-left ml-2">
        <div class="flex-column">
          <h2 class="mb-0 d-flex align-items-start" *ngIf="type === 3">
            {{ "clients.plantings.individual.set-estimated-harvest-date" | translate }}
          </h2>
          <h2 class="mb-0 d-flex align-items-start" *ngIf="type === 4">
            {{ "extended-harvest.extend-estimated-harvest-date" | translate }}
          </h2>
          <p class="m-0">{{ "extended-harvest.click-calendar-to-select-date" | translate }}</p>
        </div>
      </div>
    </div>

    <h4 class="mb-0"></h4>
  </div>
  <div class="p-3">
    <div class="row">
      <form class="w-100" [formGroup]="plannedDateForm" (submit)="register(plannedDateForm.value)">
        <div class="col-12 mt-2">
          <div class="row">
            <div class="col-5">
              <span>{{ "feed.estimated-harvest" | translate }}</span>
              <input
                type="date"
                formControlName="planned_end_date"
                name="planned_end_date"
                class="form-control"
                (change)="changePlanned('planned_end_date')"
              />
              <span class="text-danger" *ngIf="validateTextByMonthLimit()"
                >{{ "clients.cycles.planting-form.max-10-months" | translate }}</span
              >
            </div>
            <div class="col-5">
              <span>{{ "feed.estimated-days" | translate }}</span>
              <input
                formControlName="planned_days"
                type="number"
                class="form-control"
                (change)="changePlanned('planned_days')"
              />
            </div>
            <div class="col-2 d-flex justify-content-end align-items-center">
              <button class="btn btn-success" type="submit" [disabled]="validateTextByMonthLimit()">
                {{ "general.save" | translate }}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type == 2">
  <div class="text-center p-2 bg-primary">
    <h4 class="mb-0">{{ "extended-harvest.set-cycle" | translate }}</h4>
  </div>
  <div class="p-3">
    <form class="w-100" [formGroup]="seasonForm" (submit)="register(seasonForm.value)">
      <div class="row">
        <div class="col-5">
          <div class="form-group">
            <ng-container *ngIf="seasons.length > 0">
              <span>{{ "extended-harvest.season-name" | translate }}</span>
              <select class="form-control" id="season" formControlName="season" name="season">
                <option *ngFor="let item of seasons" [value]="item.id">
                  {{ item.name }}
                </option>
              </select>
            </ng-container>
          </div>
          <b *ngIf="seasons.length === 0" class="d-center"> {{ "extended-harvest.no-seasons-registered" | translate }} </b>
        </div>
        <div class="col-5">
          <span>{{ "extended-harvest.planting-alias" | translate }}</span>
          <input type="text" id="alias" formControlName="alias" name="alias" class="form-control" />
          <small>{{ "extended-harvest.optional-field" | translate }}</small>
        </div>

        <div class="col-2 d-flex justify-content-end align-items-center">
          <button class="btn btn-success" type="submit">{{ "general.save" | translate }}</button>
        </div>
      </div>
    </form>
  </div>
</ng-container>

<ng-container *ngIf="type == 1">
  <div class="text-center p-2 bg-primary">
    <h4 class="mb-0" *ngIf="type === 1">{{ "extended-harvest.set-date-and-season" | translate }}</h4>
  </div>

  <div class="p-3">
    <form
      class="w-100"
      [formGroup]="plannedDateForm"
      (submit)="register(seasonForm.value, plannedDateForm.value)"
    >
      <div class="row">
        <div class="col-5">
          <span>{{ "feed.estimated-harvest" | translate }}</span>
          <input
            type="date"
            formControlName="planned_end_date"
            name="planned_end_date"
            class="form-control"
            (change)="changePlanned('planned_end_date')"
          />
        </div>
        <div class="col-5">
          <span>{{ "feed.estimated-days" | translate }}</span>
          <input
            formControlName="planned_days"
            type="number"
            class="form-control"
            (change)="changePlanned('planned_days')"
          />
        </div>
      </div>
    </form>
    <form class="w-100" [formGroup]="seasonForm" (submit)="register(seasonForm.value)">
      <div class="row">
        <div class="col-5">
          <div class="form-group">
            <ng-container *ngIf="seasons.length > 0">
              <span>{{ "extended-harvest.season-name" | translate }}</span>
              <select class="form-control" id="season" formControlName="season" name="season">
                <option *ngFor="let item of seasons" [value]="item.id">
                  {{ item.name }}
                </option>
              </select>
            </ng-container>
          </div>
          <b *ngIf="seasons.length === 0" class="d-center"> {{ "extended-harvest.no-seasons-registered" | translate }} </b>
        </div>
        <div class="col-5">
          <span>{{ "extended-harvest.planting-alias" | translate }}</span>
          <input type="text" id="alias" formControlName="alias" name="alias" class="form-control" />
          <small>{{ "extended-harvest.optional-field" | translate }}</small>
        </div>

        <div class="col-2 d-flex justify-content-end align-items-center">
          <button class="btn btn-success" type="submit">{{ "general.save" | translate }}</button>
        </div>
      </div>
    </form>
  </div>
</ng-container>

<div class="p-3" *ngIf="type !== 2">
  <div>
    <div>
      <em class="fa fa-square" style="color: #fffadf"></em>
      {{ "clients.cycles.extend.current-day" | translate }}
    </div>
    <div>
      <em class="fa fa-square" style="color: #ffe2dc"> </em>
      {{ "clients.cycles.extend.delayed-days" | translate }}
    </div>
    <div>
      <em class="fa fa-square" style="color: #b3d9b3"> </em>
      {{ "extended-harvest.elapsed-day" | translate }}
    </div>
  </div>

  <app-calendar
    [planting]="sowData"
    [planned_end_date]="plannedDateForm.value.planned_end_date"
    (clickDate)="changeDate($event)"
  ></app-calendar>
</div>
